<ng-container *ngIf="!loader">

  <div class="form-horizontal">
    <div class="col-3">
      <!-- <div class="form-group">
        <label class="label" for="numberSpot">Номер пятна <span class="required">*</span> </label>
        <input class="form-control blink2"
               type="text"
               [formControl]="spotNumber"
               [ngClass]="spotNumber?.value?.length > 0 ? 'blink1': 'blink2'"
               id="numberSpot"
               placeholder="Номер пятна">
      </div>

      <div class="form-group">
        <label class="label" for="numberHome">Номер дома <span class="required">*</span> </label>
        <input class="form-control blink2"
               type="text"
               [formControl]="spotHomeNumber"
               [ngClass]="spotHomeNumber?.value?.length > 0 ? 'blink1' : 'blink2'"
               id="numberHome"
               placeholder="Номер дома">
      </div> -->

      <div class="form-group">
        <label class="label" for="numberSteps">Кол-во этажей </label>
        <input class="form-control"
               type="number"
               [formControl]="spotFloors"
               id="numberSteps"
               placeholder="Кол-во этажей"
               min="0">
      </div>

      <!-- <div class="col-2 text-center">
        <label class="container-checkbox">Мансарда
          <input type="checkbox"
                 [formControl]="spotHasMansard"/>
          <span class="checkmark"></span>
        </label>
      </div> -->

      <!-- <div class="typic-btn">
        <div class="btn btn-light" (click)="openTypicalFloor()">Типовые этажи</div>
      </div> -->

    </div>

    <div class="col-3 checkbox-container">
      <import-button
        [control]="spotFormGroup"
        [isPristine]="spotFormGroup.pristine"
        [buildingID]="spotObject.id"
        [floors]="spotObject.floors"
        [flats]="set4"
        (updateSpot)="getUpdateSpot($event)"></import-button>
      <button class="btn btn-light" (click)="wallModal = true">Конструктив</button>
      <button class="btn btn-light" (click)="openFinishTemplate()">Шаблон для типа отделки</button>
      <app-add-flats
        [control]="spotFormGroup"
      ></app-add-flats>
      <button class="btn btn-light" (click)="openCommercialDialog()">Коммерческие помещения</button>
      <button class="btn btn-light" (click)="openParkingDialog()">Паркоместа</button>
      <!--<div class="btn btn-light" *ngFor="let rooms of buildingRoomTypes" (click)="rooms.modal = true">
        {{ rooms.title }} + 1
      </div>-->
    </div>

    <div class="col-2">
      <div class="add-block btn" (click)="openAddBlock()">Добавить блок</div>
      <div class="add-block btn" (click)="duplicateBuilding()"> Типовое пятно</div>
      <ng-container *ngIf="addBlocModal">
        <div class="popup">
          <div>
            <input type="text" class="edit-date1" [(ngModel)]="block.blockNumber"/>
          </div>
          <div class="buttons">
            <div class="btn-accept" (click)="addBlock();">Применить</div>
            <div class="btn-decline" (click)="cancelAddBlock()">Отменить</div>
          </div>
        </div>
      </ng-container>
      <div>
        <div class="blocks" *ngFor="let block of blocks">
          <div class="btn block-btn">
            <span class="item-1" (click)="openBlock(block)">{{ block.title }} {{ block.blockNumber }}</span>
            <span class="item-close" (click)="delBlock(block.id)"></span>
          </div>
        </div>
      </div>
    </div>

    <app-modal-window *ngIf="editBlocModal == true" [title]="'Блок '+ selectedBlock.blockNumber"
                      [visible]="editBlocModal" [scrollbar]="true" (close)="editBlocModal = $event" [width]="500"
                      [height]="300">
      <app-editblock [spotID]="spotObject?.id" [block]="selectedBlock"></app-editblock>
    </app-modal-window>

    <!-- <div class="col-2">
      <label class="label">Класс жилья <span class="required">*</span> </label>
      <div class="radio-container"
           [class.blink2]="!spotFormGroup.get('rank_id')?.value">
        <label class="container-checkbox" *ngFor="let rank of spotObject?.spotRanks">
          {{ rank.title }}
          <input type="checkbox" name="spot_class" [(ngModel)]="rank.checked" (click)="changeClass(rank)">
          <span class="checkmark markRadio"></span>
        </label>
      </div>
    </div> -->

    <div class="col-2">
      <table>
        <thead>
        <th>Кол-во квартир</th>
        <th>Всего</th>
        </thead>
        <tbody class="info-table-container">
        <tr *ngFor="let floor of spotObject?.countRooms">
          <td>{{ floor.roomCountTitle }}</td>
          <td>
            {{ floor.flatCount ? floor.flatCount : '-' }}
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- <div class="wall-materials-content" *ngIf="materialIsChecked">
    <div class="wall-materials">
      <ul class="list-wall-materials">
        <ng-container *ngFor="let types of spotObject?.wallMaterials">
          <ng-container *ngFor="let type of types.wall_material">
            <li *ngIf="type.checked">
              {{ type.title }}
              <span class="item-close" (click)="type.checked = !type.checked"></span>
            </li>
          </ng-container>
        </ng-container>
      </ul>
    </div>Создание коммерческих помещений
  </div> -->

  <div class="tab-group">
    <app-spot-form-tabs
      [reloadTrigger]="reloadCommercialKey"
      [currentTabIndex]="currentTabIndex"
      [spotObject]="spotObject"
      [formGroup]="spotFormGroup"
      [obj]="obj"
      (openFlat)="chooseFlat($event)"
      (openTypicalFloor)="openTypicalFloor()"
      (deleteFlat)="deleteFlat($event.buildingID, $event.floorID, $event.roomCountID, $event.flatInfo, $event.index, $event.flatID)"
      (currentTabIndexChange)="getCurrentTabIndex($event)"
    ></app-spot-form-tabs>
  </div>



  <!-- Add appartment Modal -->
  <app-modal-window *ngIf="appartmentModal" [title]="'Добавить квартиры'" [visible]="appartmentModal" [scrollbar]="true"
                    (close)="closeAppartmentModal($event)">
    <app-add-appartment [spotObjectAddAppartments]="spotObject" [floorsCommercial]="floorsCommercial"
                        [countOfOpen]="countOfOpen" [changeAppartment]="changeAppartment">
    </app-add-appartment>
  </app-modal-window>

  <!-- Wall Material appartment Modal -->
  <app-modal-window *ngIf="wallModal" [title]="'Материал стен'" [visible]="wallModal" [height]="450" [width]="900"
                    [scrollbar]="false" (close)="wallModal = $event">
    <app-wall-material [spotObjectAddAppartments]="spotObject" [isOneChecked]="materialIsChecked"
                       (isOneChange)="materialIsChecked = $event"></app-wall-material>
  </app-modal-window>

  <!-- Flat Modal -->
  <app-modal-window *ngIf="flatFlag" [title]="appModalWindowTitle" [visible]="flatFlag" [height]="720"
                    (close)="flatFlag = $event">
    <app-flats-modal [otherRoomFlag]="otherRoomFlag" [buildingId]="spotObject?.id" [flatId]="selectedFlatId"
                     [flat]="selectedFlat" [furnishTemplate]="furnishTemplate" (confirmEventTwo)="reloadData($event);"
                     [spotForm]="spotForm"></app-flats-modal>
  </app-modal-window>

  <!-- Типовые этажи -->
  <app-modal-window *ngIf="typicFloor" [title]="'Типовые этажи'" [visible]="typicFloor" [height]="450" [width]="500"
                    [scrollbar]="false" (close)="cancelTypicFloors()">
    <div class="typic-floor-block">
      <div class="typic-floor-content">
        <div class="left-side">
          <div class="flex-row">{{ 'От:' }}</div>
          <div class="flex-row" *ngFor="let t of typicFloors;">
            <div class="floor">{{ t.floorTitle }}</div>
            <input type="radio" [value]="t.floorID" [(ngModel)]="selectedTypicFloorId" (change)="radioChange()">
          </div>
        </div>
        <div class="right-side">
          <div class="flex-row">{{ 'Какой' }}</div>
          <div class="flex-row" *ngFor="let t of typicFloors2;">
            <div class="floor">{{ t.floorTitle }}</div>
            <input type="checkbox" [value]="t.floorID" [checked]="t.isChecked" (change)="t.isChecked = !t.isChecked">
          </div>
        </div>
      </div>
      <div class="typic-floor-buttons">
        <div class="btn btn-apply" (click)="applyTypicFloors()">Подтвердить</div>
        <div class="btn btn-cancel" (click)="cancelTypicFloors()">Отменить</div>
      </div>
    </div>
  </app-modal-window>

  <!-- Building Rooms premises appartment Modal -->
  <ng-container *ngFor="let modals of buildingRoomTypes">
    <app-modal-window *ngIf="modals?.modal" [title]="modals?.title" [visible]="modals?.modal" [height]="395"
                      [width]="900" [scrollbar]="false" (close)="modals.modal = $event; ">
<!--      <app-commercial-premises *ngIf="modals?.title === 'Коммерческие помещения'"
                               [spotObjectAddAppartments]="spotObject"></app-commercial-premises>-->
      <app-auxiliary-premises *ngIf="modals?.title === 'Вспомогательные помещения'"
                              [spotObjectAddAppartments]="spotObject"></app-auxiliary-premises>
      <app-parking *ngIf="modals?.title === 'Парковка'" [spotObjectAddAppartments]="spotObject"></app-parking>
    </app-modal-window>
  </ng-container>

  <!-- Template Furnish List -->
  <app-modal-window *ngIf="furnishModal" [title]="appModalWindowTitle" [visible]="furnishModal" [width]="650"
                    [height]="620" (close)="furnishModal = $event">
    <app-typeofot [furnishListEx]="furnishTemplate" (selectedfurnishListEx)="getReturnFurnishes($event)"></app-typeofot>
  </app-modal-window>


  <app-modal-window *ngIf="openConfirmDialog" [title]="'Удалить квартиру'" [visible]="openConfirmDialog"
                    (close)="openConfirmDialog = $event" [width]="550" [height]="380">
    <div class="confirm">
      <div class="body">
        <div class="warning">
          <img src="./assets/svg-icons/warning.svg" alt="">
        </div>
        <div class="text main"> Вы уверены, что хотите удалить квартиру?</div>
        <div class="text secondary">
          В случае выбора "ДА", дальнейшее восстановление квартиры невозможно!
        </div>
      </div>
      <div class="btns">
        <div class="btn btn-apply" (click)="deleteFlatEx('yes')">ДА</div>
        <div class="btn btn-cancel" (click)="deleteFlatEx('no')">НЕТ</div>
      </div>
    </div>
  </app-modal-window>

</ng-container>
<ng-container *ngIf="loader">
  <div class="loading"></div>
</ng-container>
